import React, { useState } from 'react';
import {
  Box,
  Typography,
  Paper,
  CssBaseline,
  Container,
  AppBar,
  Toolbar,
  IconButton,
  Button,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  useTheme,
  Tooltip,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SITE_NAME } from '../../utils/constants';
import BitcoinPrice from "./BitcoinPrice.component"; // Should be the
import ConnectWallet from "./ConnectWallet.component";
import CombinedAutocomplete from "./SearchInput.component"; // Your
import LanguageToggle from './LanguageToggle.component';
import ThemeToggle from './ThemeToggle.component';

// --- RESPONSIVE APP BAR COMPONENT ---

const ResponsiveAppBarWithSearch = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const { t } = useTranslation();

  const navItems = [
    { label: t('navigation.analytics'), path: "/analytics" },
    { label: t('navigation.tokens'), path: "/tokens" },
    { label: t('navigation.leaderboard'), path: "/users/leaderboard" },
    { label: t('navigation.tradingTools'), path: "/trading-tools" },
    // { label: t('navigation.liveFeed'), path: "/events" },
    { label: t('explorer.explorer'), path: "/explorer/explore" },
  ];

  const handleDrawerToggle = () => setMobileOpen((prev) => !prev);
  const handleMobileSearchToggle = () => setMobileSearchOpen((prev) => !prev);

  const logoStyle = {
    fontFamily: "Atkinson Hyperlegible Mono, sans-serif",
    fontWeight: "700",
    fontSize: "1.75rem",
    letterSpacing: "-2px",
    cursor: "pointer",
    color: "inherit",
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center", p: 1 }}>
      <Typography variant="h6" sx={{ my: 2 }} style={logoStyle} onClick={() => navigate("/")}>
        {SITE_NAME}
      </Typography>
      <List>
        {navItems.map((item) => (
          <ListItem key={item.label} disablePadding>
            <ListItemButton sx={{ textAlign: 'center' }} onClick={() => navigate(item.path)}>
              <ListItemText primary={item.label} />
            </ListItemButton>
          </ListItem>
        ))}
        <ListItem sx={{ justifyContent: 'center', mt: 1 }}>
          <Button variant="contained" color="secondary" onClick={() => navigate("/tokens/create")}>
            {t('navigation.createNewToken')}
          </Button>
        </ListItem>
        <ListItem sx={{ justifyContent: 'center', mt: 2 }}>
          <BitcoinPrice />
        </ListItem>
        <ListItem sx={{ justifyContent: 'center', mt: 1 }}>
          <ConnectWallet />
        </ListItem>
        <ListItem sx={{ justifyContent: 'center', mt: 1 }}>
          <LanguageToggle />
        </ListItem>
        <ListItem sx={{ justifyContent: 'center', mt: 1 }}>
          <ThemeToggle />
        </ListItem>
      </List>
    </Box>
  );

  return (
    <>
      <AppBar component="nav" elevation={0}>
        <Toolbar>
          <IconButton color="inherit" aria-label="open drawer" edge="start" onClick={handleDrawerToggle} sx={{ mr: 2, display: { sm: "none" } }}>
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: { xs: 1, sm: 0 }, mr: { sm: 2 }, textAlign: { xs: "center", sm: "left" } }} style={logoStyle} onClick={() => navigate("/")}>
            {SITE_NAME}
          </Typography>
          <Box sx={{ display: { xs: "none", sm: "block" }, width: { sm: 250, md: 300 }, mr: 2 }}>
            <CombinedAutocomplete />
          </Box>
          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ display: { xs: "none", sm: "flex" }, alignItems: 'center', gap: 1 }}>
            <BitcoinPrice />
            {navItems.map((item) => (
              <Button key={item.label} variant="text" color="inherit" onClick={() => navigate(item.path)}>
                {item.label}
              </Button>
            ))}
            <Tooltip title={t('navigation.createNewToken')}>
              <Button variant="contained" color="secondary" onClick={() => navigate("/tokens/create")}>
                {t('navigation.createToken')}
              </Button>
            </Tooltip>
            <ConnectWallet />
            <LanguageToggle />
            <ThemeToggle />
          </Box>
          <Box sx={{ display: { xs: "flex", sm: "none" }, alignItems: 'center' }}>
            <IconButton color="inherit" onClick={handleMobileSearchToggle}>
              <SearchIcon />
            </IconButton>
          </Box>
        </Toolbar>
        {mobileSearchOpen && (
          <Box sx={{ p: 1, display: { xs: "block", sm: "none" } }}>
            <CombinedAutocomplete />
          </Box>
        )}
      </AppBar>

      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: "block", sm: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: 240,
            backgroundColor: '#121212',
            backgroundImage: 'none',
            borderRight: `1px solid ${ theme.palette.divider }`
          },
        }}
      >
        {drawer}
      </Drawer>
    </>
  );
};


// --- Main App Wrapper for Demonstration ---
export default ResponsiveAppBarWithSearch;